import { render } from "./ComponenteAcoplamiento.vue?vue&type=template&id=46a9032f&scoped=true"
import script from "./ComponenteAcoplamiento.vue?vue&type=script&lang=js"
export * from "./ComponenteAcoplamiento.vue?vue&type=script&lang=js"

import "./ComponenteAcoplamiento.vue?vue&type=style&index=0&id=46a9032f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a9032f"]])

export default __exports__